import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-xs-right" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { class: "text-center pl-3 pb-2" }
const _hoisted_10 = { class: "align-center" }
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = { class: "align-center" }
const _hoisted_13 = { class: "align-center" }
const _hoisted_14 = { class: "text-center pl-3 pb-2" }
const _hoisted_15 = { class: "mx-2" }
const _hoisted_16 = { class: "align-center" }
const _hoisted_17 = { class: "align-center" }
const _hoisted_18 = { class: "align-center" }
const _hoisted_19 = { class: "align-center" }
const _hoisted_20 = { class: "align-center" }
const _hoisted_21 = { class: "align-center" }
const _hoisted_22 = { class: "text-center pl-3 pb-2" }
const _hoisted_23 = {
  key: 0,
  "data-cy": "stockOperations-stock"
}
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_InvoiceHtmlTemplateView = _resolveComponent("InvoiceHtmlTemplateView")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_progress_linear, {
            height: "10",
            indeterminate: ""
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_card, {
        key: 1,
        style: {"background-color":"transparent"},
        elevation: "0",
        class: "mx-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "no-padding" }, {
            default: _withCtx(() => [
              (_ctx.wizardStep !== 0)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    class: "my-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "d-flex align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_icon, {
                            variant: "flat",
                            icon: "$navigate_before",
                            elevation: "0",
                            color: "primary",
                            size: "x-small",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previous()))
                          }),
                          _createVNode(_component_v_select, {
                            class: "pl-3",
                            "hide-details": "",
                            outlined: "",
                            modelValue: _ctx.selectedUserId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedUserId) = $event)),
                            items: _ctx.users,
                            "item-props": true,
                            "item-title": (item) => _ctx.getUserDisplayName(item),
                            "item-value": "id",
                            label: "Signataire",
                            disabled: _ctx.wizardStep === 2,
                            loading: _ctx.stockInventoriesLoading,
                            density: "compact"
                          }, {
                            item: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _mergeProps({ class: "oss-list-item" }, props), {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    color: "secondary",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getUserBigram(props)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "items", "item-title", "disabled", "loading"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "2",
                        class: "pl-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_picker, {
                            modelValue: _ctx.date,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
                            "text-field-readonly": false,
                            "hide-details": "auto",
                            disabled: _ctx.wizardStep === 2,
                            onChangeDate: _ctx.onDateChanged
                          }, null, 8, ["modelValue", "disabled", "onChangeDate"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "pl-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            outlined: "",
                            readonly: "",
                            label: "État",
                            "hide-details": "",
                            "model-value": _ctx.selectedStatus.text,
                            density: "compact"
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      (_ctx.wizardStep === 2)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "1",
                            class: "d-flex align-center justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps({
                                    icon: "$oss-download",
                                    elevation: "0",
                                    density: "compact"
                                  }, props, {
                                    onClick: _ctx.printInventory,
                                    disabled: _ctx.disabledDownload(),
                                    loading: _ctx.downloadLoading,
                                    style: {"margin-left":"4px","margin-right":"4px"}
                                  }), null, 16, ["onClick", "disabled", "loading"])
                                ]),
                                default: _withCtx(() => [
                                  _cache[26] || (_cache[26] = _createElementVNode("span", null, "Télécharger", -1))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps({
                                    icon: !_ctx.showDocumentPreview ? '$oss-eye' : '$oss-edit',
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDocumentPreview = !_ctx.showDocumentPreview))
                                  }, props, {
                                    density: "compact",
                                    style: {"margin-left":"4px","margin-right":"4px"}
                                  }), null, 16, ["icon"])
                                ]),
                                default: _withCtx(() => [
                                  (!_ctx.showDocumentPreview)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Prévisualiser le document"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_2, "Afficher la liste"))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.wizardStep === 1)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: "2",
                            class: "d-flex align-center justify-end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                rounded: "",
                                elevation: "0",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveInventory())),
                                disabled: _ctx.disabledValid,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.selectedInventoryId ? "Sauvegarder" : "Enregistrer"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.wizardStep === 2)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 2,
                            cols: "3",
                            class: "d-flex align-center justify-end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                rounded: "",
                                elevation: "0",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wizardStep = 1)),
                                disabled: _ctx.selectedStatus.value === 'VALIDATED',
                                class: "mx-2",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                  _createTextVNode(" Éditer ")
                                ])),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_btn, {
                                rounded: "",
                                elevation: "0",
                                disabled: _ctx.selectedStatus.value === 'VALIDATED',
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateInventory())),
                                class: "mx-2",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                  _createTextVNode(" Valider l'inventaire ")
                                ])),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.wizardStep !== 0 && _ctx.reverseError)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "px-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, {
                            dismissible: "",
                            type: "warning",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.reverseError = false)),
                            "model-value": _ctx.reverseError,
                            density: "compact"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.errorList[_ctx.errorIndex]), 1)
                            ]),
                            _: 1
                          }, 8, ["model-value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_window, {
                modelValue: _ctx.wizardStep,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.wizardStep) = $event)),
                touchless: "",
                class: "elevation-0",
                style: {"background":"transparent"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: 0 }, {
                    default: _withCtx(() => [
                      (!_ctx.$vuetify.display.mobile)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": "",
                            class: "my-3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_menu, { location: "end" }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_btn_primary, _mergeProps(props, {
                                        block: "",
                                        "data-cy": "invoices-new-invoice"
                                      }), {
                                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                                          _createTextVNode(" Ajouter ")
                                        ])),
                                        _: 2
                                      }, 1040)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, {
                                        nav: "",
                                        density: "compact"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item, {
                                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startNewInventory(true))),
                                            title: "Inventaire à remplir"
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_icon, {
                                                icon: "$oss-edit",
                                                size: "small",
                                                location: "start"
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, {
                                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.startNewInventory(false))),
                                            title: "Inventaire pré-rempli"
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_icon, {
                                                icon: "$oss-edit",
                                                size: "small",
                                                location: "start"
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "10",
                                class: "pl-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.search,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.search) = $event)),
                                    "append-inner-icon": "$fa-search",
                                    clearable: "",
                                    "onClick:clear": _cache[11] || (_cache[11] = ($event: any) => (_ctx.search = '')),
                                    label: "Recherche",
                                    regular: "",
                                    outlined: "",
                                    "hide-details": "",
                                    autofocus: "",
                                    density: "compact"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_data_table, {
                        headers: _ctx.inventoryHeaders,
                        items: _ctx.inventories,
                        "items-per-page-options": _ctx.itemsPerPageOptions,
                        "fixed-header": "",
                        "max-height": "60vh",
                        "multi-sort": false,
                        class: "table"
                      }, {
                        item: _withCtx(({ item }) => [
                          _createElementVNode("tr", {
                            "data-cy": "invoices-invoice",
                            onClick: ($event: any) => (_ctx.openInventory(item.id))
                          }, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.date) || "-"), 1),
                            _createElementVNode("td", null, _toDisplayString(item.signer.firstname + " " + item.signer.lastname || "-"), 1),
                            _createElementVNode("td", null, _toDisplayString(item.accountingClosing ? item.accountingClosing.name : "-"), 1),
                            _cache[30] || (_cache[30] = _createElementVNode("td", null, _toDisplayString("-"), -1)),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_chip, {
                                size: "small",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: "$labl_icon",
                                    size: "small",
                                    style: {"margin-right":"4px"}
                                  }),
                                  _createTextVNode(" " + _toDisplayString(item.status === "EDITION" ? "Brouillon" : "Validé"), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_btn_trash, {
                                "x-small": "",
                                onClick: _withModifiers(($event: any) => (_ctx.selectInventoryForDeletion(item)), ["stop"])
                              }, null, 8, ["onClick"])
                            ])
                          ], 8, _hoisted_3)
                        ]),
                        _: 1
                      }, 8, ["headers", "items", "items-per-page-options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_data_table, {
                        headers: _ctx.stockHeaders,
                        items: _ctx.stockLines,
                        class: "table strong-border",
                        "fixed-header": "",
                        "max-height": "60vh",
                        "multi-sort": false,
                        loading: _ctx.stockLinesLoading,
                        "no-data-text": 'Aucun produit ajouté',
                        "hide-default-footer": ""
                      }, {
                        item: _withCtx(({ item, index }) => [
                          (item.show)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 0,
                                "data-cy": "stockOperations-stock",
                                style: _normalizeStyle(_ctx.getRowStyle(item))
                              }, [
                                (item.father)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("td", _hoisted_4, [
                                        (item.father)
                                          ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                              key: 0,
                                              icon: 
                                                item.expand
                                                    ? '$keyboard_arrow_up'
                                                    : '$keyboard_arrow_down'
                                            ,
                                              onClick: ($event: any) => (_ctx.handleVisibility(item))
                                            }, null, 8, ["icon", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(item.invoiceProduct.title || "-"), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.invoiceProduct.reference || "-"), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.stockAccount.name || "-"), 1),
                                      _createElementVNode("td", _hoisted_5, _toDisplayString(item.quantity), 1),
                                      _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.newCommonFormatCurrency(item.totalAmount, undefined)), 1),
                                      _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                item.stockAmountSigned,
                                                undefined,
                                            )), 1),
                                      _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                item.depreciatedAmountSigned,
                                                undefined,
                                            )), 1),
                                      _createElementVNode("td", _hoisted_9, [
                                        _createVNode(_component_v_btn_trash, {
                                          onClick: ($event: any) => (_ctx.deleteRow(index, 3)),
                                          size: "x-small"
                                        }, null, 8, ["onClick"])
                                      ])
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[31] || (_cache[31] = _createElementVNode("td", { class: "text-xs-right" }, null, -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.invoiceProduct.title || "-"), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.invoiceProduct.reference || "-"), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.stockAccount.name || "-"), 1),
                                      _createElementVNode("td", _hoisted_10, [
                                        _createVNode(_component_oss_text_field_filled, {
                                          "hide-details": true,
                                          class: "ml-2 righted-input",
                                          modelValue: item.quantity,
                                          "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                                          onChange: ($event: any) => (_ctx.onQuantityChanged(item))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                      ]),
                                      _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.newCommonFormatCurrency(item.totalAmount, undefined) ||
                                            ""), 1),
                                      _createElementVNode("td", _hoisted_12, [
                                        _createVNode(_component_oss_text_field_filled, {
                                          "hide-details": true,
                                          suffix: "€",
                                          class: "ml-2 righted-input",
                                          modelValue: item.stockAmountSigned,
                                          "onUpdate:modelValue": ($event: any) => ((item.stockAmountSigned) = $event),
                                          onChange: ($event: any) => (_ctx.onAmountsChanged(item))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                      ]),
                                      _createElementVNode("td", _hoisted_13, [
                                        _createVNode(_component_oss_text_field_filled, {
                                          "hide-details": true,
                                          suffix: "€",
                                          class: "ml-2 righted-input",
                                          modelValue: item.depreciatedAmountSigned,
                                          "onUpdate:modelValue": ($event: any) => ((item.depreciatedAmountSigned) = $event),
                                          error: item.variableAmountError,
                                          onChange: ($event: any) => (_ctx.onAmountsChanged(item))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "onChange"])
                                      ]),
                                      _createElementVNode("td", _hoisted_14, [
                                        (item.childOf === null)
                                          ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                              key: 0,
                                              onClick: ($event: any) => (_ctx.deleteRow(index, 1)),
                                              size: "x-small"
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 64))
                              ], 4))
                            : _createCommentVNode("", true)
                        ]),
                        "body.append": _withCtx(() => [
                          _createElementVNode("tr", _hoisted_15, [
                            _cache[32] || (_cache[32] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", _hoisted_16, [
                              _createVNode(_component_v_text_field_filled, {
                                "hide-details": true,
                                outlined: "",
                                modelValue: _ctx.newStockLine.title,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newStockLine.title) = $event)),
                                density: "compact"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_17, [
                              _createVNode(_component_v_text_field_filled, {
                                "hide-details": true,
                                outlined: "",
                                modelValue: _ctx.newStockLine.reference,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newStockLine.reference) = $event)),
                                density: "compact"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_18, [
                              _createVNode(_component_v_select_filled, {
                                "hide-details": "",
                                outlined: "",
                                style: {"pointer-events":"auto"},
                                modelValue: _ctx.newStockLine.stockAccount1,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newStockLine.stockAccount1) = $event)),
                                items: _ctx.stock_names,
                                "return-object": "",
                                class: "v-select-font-size",
                                density: "compact",
                                "item-title": (item) => item.name
                              }, null, 8, ["modelValue", "items", "item-title"])
                            ]),
                            _createElementVNode("td", _hoisted_19, [
                              _createVNode(_component_oss_text_field_filled, {
                                "hide-details": true,
                                class: "ml-2 righted-input",
                                modelValue: _ctx.newStockLine.quantity,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newStockLine.quantity) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _cache[33] || (_cache[33] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", _hoisted_20, [
                              _createVNode(_component_oss_text_field_filled, {
                                "hide-details": true,
                                suffix: "€",
                                class: "ml-2 righted-input",
                                modelValue: _ctx.newStockLine.stockAmountSigned,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newStockLine.stockAmountSigned) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_21, [
                              _createVNode(_component_oss_text_field_filled, {
                                "hide-details": true,
                                suffix: "€",
                                class: "ml-2 righted-input",
                                modelValue: _ctx.newStockLine.depreciatedAmountSigned,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newStockLine.depreciatedAmountSigned) = $event)),
                                error: _ctx.newStockLine.variableAmountError
                              }, null, 8, ["modelValue", "error"])
                            ]),
                            _createElementVNode("td", _hoisted_22, [
                              _createVNode(_component_v_btn_icon, {
                                variant: "flat",
                                icon: "$add",
                                size: "small",
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.addRow())),
                                disabled: _ctx.disabledAdd,
                                elevation: "0",
                                color: "primary"
                              }, null, 8, ["disabled"])
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["headers", "items", "loading"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "py-2"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.showDocumentPreview)
                                ? (_openBlock(), _createBlock(_component_InvoiceHtmlTemplateView, {
                                    key: 0,
                                    ref: "invoicePreviewRef",
                                    invoiceThemeSettings: _ctx.invoiceThemeSettings,
                                    invoiceData: _ctx.previewData,
                                    quotation: null,
                                    forPrint: false,
                                    company: _ctx.companyFullData,
                                    backgroundImage: _ctx.backgroundImage,
                                    additionalDocument: _ctx.additionalDocument,
                                    onDomInfo: _cache[19] || (_cache[19] = ($event: any) => (_ctx.invoiceDomInfo = $event)),
                                    hideExtraDocument: ""
                                  }, null, 8, ["invoiceThemeSettings", "invoiceData", "company", "backgroundImage", "additionalDocument"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_spacer)
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createVNode(_component_v_data_table, {
                        headers: _ctx.stockHeaders.slice(0, 8),
                        items: _ctx.stockLines,
                        class: "table",
                        "fixed-header": "",
                        "max-height": "60vh",
                        "multi-sort": false
                      }, {
                        item: _withCtx(({ item, index }) => [
                          (!item.father && item.quantity)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                                _cache[34] || (_cache[34] = _createElementVNode("td", null, null, -1)),
                                _createElementVNode("td", null, _toDisplayString(item.invoiceProduct.title || "-"), 1),
                                _createElementVNode("td", null, _toDisplayString(item.invoiceProduct.reference || "-"), 1),
                                _createElementVNode("td", _hoisted_24, _toDisplayString(item.stockAccount.name || "-"), 1),
                                _createElementVNode("td", _hoisted_25, _toDisplayString(item.quantity || "-"), 1),
                                _createElementVNode("td", _hoisted_26, _toDisplayString(item.totalAmount || "-"), 1),
                                _createElementVNode("td", _hoisted_27, _toDisplayString(item.stockAmountSigned || "0"), 1),
                                _createElementVNode("td", _hoisted_28, _toDisplayString(item.depreciatedAmountSigned || "0"), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["headers", "items"]), [
                        [_vShow, !_ctx.showDocumentPreview]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_oss_dialog, {
            title: "Confirmation",
            modelValue: _ctx.dialogConfirmInventory,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.dialogConfirmInventory) = $event)),
            onValid: _cache[22] || (_cache[22] = ($event: any) => {
                _ctx.confirmInventory();
                _ctx.dialogConfirmInventory = false;
            }),
            "max-width": "40vw"
          }, {
            default: _withCtx(() => _cache[35] || (_cache[35] = [
              _createElementVNode("div", null, " Voulez-vous vraiment valider ce document ? Cette action ne peut pas être annulée ", -1)
            ])),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_oss_dialog, {
            title: "Attention",
            modelValue: _ctx.negativeStockDialog,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.negativeStockDialog) = $event)),
            "max-width": "40vw"
          }, {
            default: _withCtx(() => _cache[36] || (_cache[36] = [
              _createElementVNode("div", null, "Vous avez une valeur négative en stock, veuillez vérifier", -1)
            ])),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.inventoryToDeleteId)
            ? (_openBlock(), _createBlock(_component_oss_dialog, {
                key: 0,
                modelValue: _ctx.deleteInventoryDialog,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.deleteInventoryDialog) = $event)),
                title: "Suppression de l'inventaire",
                onValid: _cache[25] || (_cache[25] = ($event: any) => (_ctx.deleteInventory(_ctx.inventoryToDeleteId))),
                validLoading: _ctx.deleteInventoryLoading,
                width: "550px"
              }, {
                default: _withCtx(() => _cache[37] || (_cache[37] = [
                  _createElementVNode("h4", { class: "text-center" }, " Étes-vous sûr(e) de vouloir supprimer cet inventaire ? Cette action est irréversible ", -1)
                ])),
                _: 1
              }, 8, ["modelValue", "validLoading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
}